/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Cookie } from '../../models/cookie';
import { CookieApiRespModel } from '../../models/cookie-api-resp-model';

export interface ApiMasterCookieEditCookiePost$Params {
      body?: Cookie
}

export function apiMasterCookieEditCookiePost(http: HttpClient, rootUrl: string, params?: ApiMasterCookieEditCookiePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCookieEditCookiePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CookieApiRespModel>;
    })
  );
}

apiMasterCookieEditCookiePost.PATH = '/api/Master/Cookie/EditCookie';
